module.exports = __webpack_public_path__ + "static/media/campuses.5ff6e092.webm";